module.exports = __webpack_public_path__ + "images/dd71b2f73675835b9fc6df31ee351f23.jpg";